// src/components/pos/pos.constants.js
// Single source of truth for all POS configuration constants

export const POS_MODES = {
  standard:    { key: 'standard',    label: 'Standard',         icon: 'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z' },
  jewellery:   { key: 'jewellery',   label: 'Jewellery / Gold', icon: 'M6 3h12l4 6-10 13L2 9l4-6z' },
  grocery:     { key: 'grocery',     label: 'Grocery / Dept.',  icon: 'M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17' },
  pharmacy:    { key: 'pharmacy',    label: 'Pharmacy',         icon: 'M12 2v20M2 12h20M7 7l5-5 5 5M7 17l5 5 5-5' },
  clothing:    { key: 'clothing',    label: 'Clothing / Fashion',icon: 'M20.38 3.46L16 2a4 4 0 01-8 0L3.62 3.46a2 2 0 00-1.34 2.23l.58 3.57a1 1 0 00.99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.15a1 1 0 00.99-.84l.58-3.57a2 2 0 00-1.34-2.23z' },
  fresh_food:  { key: 'fresh_food',  label: 'Fresh Food',       icon: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' },
  electronics: { key: 'electronics', label: 'Electronics',      icon: 'M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v11m0 0H5a2 2 0 00-2 2v4a2 2 0 002 2h4m0-6h6m0 0v6a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-2-2h-4m-6 0V9a2 2 0 012-2h4a2 2 0 012 2v6' },
  fastfood:    { key: 'fastfood',    label: 'Fast Food / Restaurant', icon: 'M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8zM6 1v3M10 1v3M14 1v3' },
  bakery:      { key: 'bakery',      label: 'Bakery / Café',    icon: 'M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 002 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z' },
  salon:       { key: 'salon',       label: 'Salon / Beauty / Spa', icon: 'M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z' },
  repair:      { key: 'repair',      label: 'Repair / Workshop', icon: 'M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z' },
  fabric:      { key: 'fabric',      label: 'Fabric / Textile',  icon: 'M3 21l18-18M3 3l18 18' },
  service:     { key: 'service',     label: 'General Service',   icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2' },
}

export const PAYMENT_METHODS = [
  { key: 'Cash',          label: 'Cash',         color: '#16A34A', bg: '#F0FDF4', border: '#BBF7D0' },
  { key: 'bKash',         label: 'bKash',        color: '#E2136E', bg: '#FFF0F7', border: '#FBBEDD' },
  { key: 'Nagad',         label: 'Nagad',        color: '#F05A28', bg: '#FFF3EE', border: '#FDCBB8' },
  { key: 'Rocket',        label: 'Rocket',       color: '#7C3AED', bg: '#F5F3FF', border: '#DDD6FE' },
  { key: 'Card',          label: 'Card',         color: '#1D4ED8', bg: '#EFF6FF', border: '#BFDBFE' },
  { key: 'Bank Transfer', label: 'Bank',         color: '#0369A1', bg: '#F0F9FF', border: '#BAE6FD' },
  { key: 'Store Credit',  label: 'Credit',       color: '#D97706', bg: '#FFFBEB', border: '#FDE68A' },
  { key: 'Old Gold',      label: 'Old Gold',     color: '#B45309', bg: '#FEF3C7', border: '#FCD34D' }, // jewellery only
  { key: 'Split',         label: 'Split',        color: '#6B7280', bg: '#F9FAFB', border: '#E5E7EB' },
]

export const KARAT_OPTIONS = [
  { key: '24K', label: '24K (999)', purity: 0.999 },
  { key: '22K', label: '22K (916)', purity: 0.916 },
  { key: '21K', label: '21K (875)', purity: 0.875 },
  { key: '18K', label: '18K (750)', purity: 0.750 },
  { key: '14K', label: '14K (585)', purity: 0.585 },
  { key: 'Silver 925', label: 'Silver 925', purity: 0.925 },
  { key: 'Silver 999', label: 'Silver 999', purity: 0.999 },
  { key: 'Platinum',   label: 'Platinum 950', purity: 0.950 },
]

export const MAKING_CHARGE_TYPES = [
  { key: 'per_gram', label: 'Per gram' },
  { key: 'flat',     label: 'Flat per item' },
  { key: 'percent',  label: '% of gold value' },
  { key: 'none',     label: 'No making charge' },
]

export const UNIT_TYPES = {
  piece:  { label: 'Piece',   short: 'pc',  decimal: false },
  gram:   { label: 'Gram',    short: 'g',   decimal: true  },
  kg:     { label: 'KG',      short: 'kg',  decimal: true  },
  litre:  { label: 'Litre',   short: 'L',   decimal: true  },
  ml:     { label: 'ml',      short: 'ml',  decimal: true  },
  metre:  { label: 'Metre',   short: 'm',   decimal: true  },
  yard:   { label: 'Yard',    short: 'yd',  decimal: true  },
  dozen:  { label: 'Dozen',   short: 'dz',  decimal: false },
  pack:   { label: 'Pack',    short: 'pk',  decimal: false },
  box:    { label: 'Box',     short: 'bx',  decimal: false },
  hour:   { label: 'Hour',    short: 'hr',  decimal: true  },
  session:{ label: 'Session', short: 'sess',decimal: false },
}

// Which payment methods are visible per mode
export const MODE_PAYMENT_METHODS = {
  default:    ['Cash','bKash','Nagad','Rocket','Card','Bank Transfer','Split'],
  jewellery:  ['Cash','bKash','Nagad','Rocket','Card','Bank Transfer','Old Gold','Split'],
}

// Mode-specific extra fields shown on product tiles
export const MODE_PRODUCT_FIELDS = {
  jewellery:   ['gold_karat', 'gold_weight', 'making_charge', 'hallmark_number', 'stone_value'],
  pharmacy:    ['batch_number', 'expiry_date', 'requires_prescription', 'medicine_generic'],
  fresh_food:  ['unit_type', 'unit_price_per', 'expiry_date'],
  grocery:     ['unit_type', 'unit_price_per'],
  fabric:      ['unit_type', 'unit_price_per'],
  bakery:      ['unit_type'],
  repair:      ['is_service', 'service_duration_min'],
  salon:       ['is_service', 'service_duration_min'],
  service:     ['is_service', 'service_duration_min'],
}

// Return/exchange types
export const RETURN_TYPES = {
  return:   { label: 'Return',   desc: 'Customer returns item, gets cash refund' },
  replace:  { label: 'Replace',  desc: 'Same item, different variant/size — even exchange' },
  exchange: { label: 'Exchange', desc: 'Different item — price difference charged or refunded' },
}

// Staff roles
export const STAFF_ROLES = {
  owner:    { label: 'Owner',    canVoid: true,  canOverrideReturn: true, canViewReports: true, canManageStaff: true },
  manager:  { label: 'Manager', canVoid: true,  canOverrideReturn: true, canViewReports: true, canManageStaff: false },
  cashier:  { label: 'Cashier', canVoid: false, canOverrideReturn: false, canViewReports: false, canManageStaff: false },
}

// Mode-specific receipt fields
export const MODE_RECEIPT_FIELDS = {
  jewellery: ['gold_karat', 'gold_weight', 'gold_rate_used', 'making_charge', 'stone_value', 'hallmark_number', 'old_gold_value'],
  pharmacy:  ['batch_number', 'expiry_date', 'medicine_generic'],
  repair:    ['job_card_number', 'technician_name', 'advance_paid', 'estimated_ready'],
  salon:     ['technician_name', 'service_duration'],
  fastfood:  ['table_number', 'cover_count', 'kot_number'],
}